'use strict';

function cookieFunction(g) {
  function cookieAccept() {
    var $noticeCookie = $(".notice-cookie");
    var $expDate = new Date();
    var $valueCookie = $expDate.getTime();

    $noticeCookie.find("a.button").on("click", function() {
      $expDate.setFullYear($expDate.getFullYear() + 1);
      $(this).setCookie("WP-COOKIE-ACCEPT", $valueCookie, $expDate, $cookiePathApp, $cookieDomainApp);
      $noticeCookie.addClass("notice-cookie-hide");
    });
  };

  function init() {
    cookieAccept();
  }

  init();
}

/**
 * Méthode getcookie
 * @param name
 * @returns {undefined}
 */
$.fn.getCookie = function(name) {
  var cookies = document.cookie.split("; "),
      returnValue = undefined;

  $(cookies).each(function(key, value) {
      if (value.indexOf(name) != -1) {
          returnValue = value.split("=")[1];
      }
  });

  return returnValue;
};

/**
 * Méthode setcookie
 * @param name, value, expire, path, domain, security
 * @returns {undefined}
 */
$.fn.setCookie = function(name, value, expire, path, domain, security) {
    document.cookie = name + " = " + value + "  " +
        ( ( expire == undefined ) ? "" : ( "; expires = " + expire.toGMTString() ) ) +
        ( ( path == undefined ) ? "" : ( "; path = " + path ) ) +
        ( ( domain == undefined ) ? "" : ( "; domain = " + domain ) ) +
        ( ( security == true ) ? "; secure" : ""
        );
};
